// extracted by mini-css-extract-plugin
export default {"root":"StatusTag_root__+ZbkU","wrapper":"StatusTag_wrapper__zaGOg","label":"StatusTag_label__v3tcd","printingLabel":"StatusTag_printingLabel__Yx1R9"};